import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Clock, ListChecks } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";

const Wachten = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const detail = location.state?.detail;

  return (
    <div className="mx-auto max-w-2xl px-4 py-12 sm:px-6 lg:px-8" data-testid="wachten-page">
      <Card className="p-6 sm:p-8">
        <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary/10 text-primary">
          <Clock className="h-5 w-5" aria-hidden="true" />
        </span>
        <h1 className="mt-5 font-display text-2xl font-semibold tracking-tight">
          {t("auth.wachten.title")}
        </h1>
        <p className="mt-3 text-sm leading-6 text-muted-foreground">
          {t("auth.wachten.subtitle")}
        </p>

        {detail && (
          <Alert className="mt-5" data-testid="wachten-detail-alert">
            <AlertDescription>{detail}</AlertDescription>
          </Alert>
        )}

        <ul className="mt-6 space-y-3">
          {["one", "two", "three"].map((key) => (
            <li key={key} className="flex items-start gap-3 text-sm">
              <ListChecks className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
              <span>{t(`auth.wachten.steps.${key}`)}</span>
            </li>
          ))}
        </ul>

        <p className="mt-6 rounded-md border bg-secondary p-4 text-sm text-muted-foreground">
          {t("auth.wachten.hint")}
        </p>

        <div className="mt-6 flex flex-wrap gap-3">
          <Button asChild data-testid="wachten-login-button">
            <Link to="/login">{t("auth.wachten.backToLogin")}</Link>
          </Button>
          <Button variant="outline" asChild data-testid="wachten-home-button">
            <Link to="/">{t("auth.wachten.backHome")}</Link>
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default Wachten;
